import React, { Component } from 'react';
import { connect } from 'react-redux';
import PageTitle from '~/components/PageTitle';

import FanList from './FanList';
import FanDetail from './FanDetail';
import SubmarineList from './SubmarineList';
import SubmarineDetail from './SubmarineDetail';

class Page_PPFan extends Component {
  state={
    fanData: { id: '', open: false, mode: '', doRefresh: false },
    submarineData: { id: '', open: false, mode: '', doRefresh: false },
  }

  componentDidMount () {
    const queryParams = new URLSearchParams(this.props.location.search);
    const ppFanId = queryParams.get('id');
    const assignedWindcontractId = queryParams.get('contractId');

    if (ppFanId || assignedWindcontractId) {
      const { fanData } = this.state;
      localStorage.setItem('Wind_ID', assignedWindcontractId);
      const body = { "id": ppFanId, "open": true, "mode": "edit" };
      this.setState({ fanData: { ...fanData, ...body } });
    }
  }
  
  handleFanData=(body = {}) => {
    const { fanData } = this.state;
    this.setState({ fanData: { ...fanData, ...body } });
  }

  handleSubmarineData=(body = {}) => {
    const { submarineData } = this.state;
    this.setState({ submarineData: { ...submarineData, ...body } });
  }

  render () {
    const { fanData, submarineData } = this.state;
    const ary = [
      <div
        key='Page_PPFan_Main'
        style={{
          position: 'absolute',
          left: 13,
          right: 0,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'start',
          overflow: 'auto',
        }}
      >
        <PageTitle text='風機點位工進' />
        <FanList handleFanData={this.handleFanData} {...fanData} />
        <SubmarineList handleSubmarineData={this.handleSubmarineData} {...submarineData} />
        {/* <div style={{ marginTop: 24 }}>---圖表待討論---</div> */}
      </div>,
    ];
    if (fanData.open) ary.push(<FanDetail key='Page_PPFan_FanDetail' {...fanData} _onClose={() => this.handleFanData({ id: '', open: false, mode: '', doRefresh: true })} />);
    if (submarineData.open) ary.push(<SubmarineDetail key='Page_PPFan_SubmarineDetail' {...submarineData} _onClose={() => this.handleSubmarineData({ id: '', open: false, mode: '', doRefresh: true })} />);
    return ary;
  }
}
const mapStateToProps = state => ({
  // userListInfo: state.data.UserList,
});
const mapDispatchToProps = dispatch => ({
  // getUserList: body => Actions.getUserList(dispatch, body),
  // deleteUser: id => Actions.deleteUser(dispatch, { id }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Page_PPFan);
